module.exports = __webpack_public_path__ + "img/marker.3edb176d.png";